<ng-container *ngIf="shared.isLoggedIn(true)">
  <!-- ============ TOP HEADER (stejný pro admin i user) ============ -->
  <div class="d-flex align-items-center rep-topbar p-2 px-3">
    <img alt="Logo" class="main-logo cursor" src="assets/logo.png" routerLink="/dashboard">

    <div class="ms-auto d-flex align-items-center gap-2">
      <!-- Tlačítko Nová rezervace - pro admin i uživatele -->
      <a [routerLink]="isAdmin ? '/admin/reservations/new' : '/reservations/new'" class="btn btn-accent">
        <i class="bi bi-plus-circle me-1"></i>
        <span class="d-none d-sm-inline">{{ 'reservations.title_new' | translate }}</span>
        <span class="d-sm-none">{{ 'header.new_short' | translate }}</span>
      </a>
      <!-- Hamburger menu -->
      <button class="btn btn-menu-toggle" (click)="openMenu(menuOffcanvas)">
        <i class="bi bi-list"></i>
      </button>
    </div>
  </div>

  <!-- ============ OFFCANVAS MENU ============ -->
  <ng-template #menuOffcanvas>
    <div class="offcanvas-header border-bottom">
      <h5 class="offcanvas-title">{{ 'header.menu_title' | translate }}</h5>
      <button type="button" class="btn-close" (click)="offcanvasService.dismiss()"></button>
    </div>
    <div class="offcanvas-body d-flex flex-column">
      <div class="nav-links d-flex flex-column flex-grow-1">

        <!-- ADMIN menu položky -->
        <ng-container *ngIf="isAdmin">
          <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-house me-3"></i>
            <span>{{ 'header.menu_dashboard' | translate }}</span>
          </a>
          <a routerLink="/admin/reservations" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-calendar-check me-3"></i>
            <span>{{ 'header.menu_admin_reservations' | translate }}</span>
          </a>
          <a routerLink="/admin/locations" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-geo-alt me-3"></i>
            <span>{{ 'header.menu_admin_locations' | translate }}</span>
          </a>
          <a *ngIf="isSuperAdmin" routerLink="/admin/clients" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-building me-3"></i>
            <span>{{ 'header.menu_admin_clients' | translate }}</span>
          </a>
          <a *ngIf="isSuperAdmin" routerLink="/admin/users" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-people me-3"></i>
            <span>{{ 'header.menu_admin_users' | translate }}</span>
          </a>
          <a *ngIf="isSuperAdmin" routerLink="/admin/settings" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-gear me-3"></i>
            <span>{{ 'header.menu_admin_settings' | translate }}</span>
          </a>
          <a routerLink="/stations-map" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-map me-3"></i>
            <span>{{ 'header.menu_stations_map' | translate }}</span>
          </a>
        </ng-container>

        <!-- USER menu položky -->
        <ng-container *ngIf="!isAdmin">
          <a routerLink="/dashboard" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-house me-3"></i>
            <span>{{ 'header.menu_dashboard' | translate }}</span>
          </a>
          <a routerLink="/reservations" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-calendar-check me-3"></i>
            <span>{{ 'header.menu_my_reservations' | translate }}</span>
          </a>
          <a routerLink="/reservations/new" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-plus-circle me-3"></i>
            <span>{{ 'header.menu_new_reservation' | translate }}</span>
          </a>
          <a routerLink="/stations-map" routerLinkActive="active" class="nav-link py-3 border-bottom" (click)="offcanvasService.dismiss()">
            <i class="bi bi-map me-3"></i>
            <span>{{ 'header.menu_stations_map' | translate }}</span>
          </a>
        </ng-container>

        <div class="flex-grow-1"></div>

        <!-- Language switcher -->
        <div class="mt-4 pt-3 border-top">
          <div class="small text-muted mb-2"><i class="bi bi-translate me-1"></i>{{ 'header.language' | translate }}</div>
          <s-select name="lang" [items]="languageOptions" bindLabel="label" bindValue="value"
            [clearable]="false" [searchable]="false"
            [model]="currentLang" (change)="changeLanguage($event?.value)">
          </s-select>
        </div>

        <!-- User info -->
        <div class="user-info mt-3 pt-3 border-top">
          <div class="small text-muted">{{ 'header.logged_as' | translate }}</div>
          <div class="fw-bold">{{ userName }}</div>
          <div class="small text-muted mt-1" *ngIf="clientName">
            <i class="bi bi-building me-1"></i>{{ clientName }}
          </div>
          <span class="badge bg-warning text-dark mt-1" *ngIf="isAdmin">{{ 'header.role_admin' | translate }}</span>
        </div>

        <!-- Logout -->
        <button class="btn btn-outline-danger btn-sm w-100 mt-3" (click)="logout(); offcanvasService.dismiss()">
          <i class="bi bi-box-arrow-right me-2"></i>
          {{ 'header.logout' | translate }}
        </button>

        <div class="version text-muted text-center mt-3 small">v{{ version }}</div>
      </div>
    </div>
  </ng-template>
</ng-container>
